import { defineNuxtPlugin } from '#imports'
import { useLogger } from '~/composables/useLogger'
import { useUserAccess } from '~/composables/useUserAccess'

const logger = useLogger('apiProblemReactions')

const logFailure = (error: unknown): void => {
  logger.error('refreshUserAccessFailed', {
    errorName: error instanceof Error ? error.name : 'UnknownError'
  })
}

// The refresh is not awaited: it would make every failed request wait on a second one, and /api/user/access is exempt from this 409 so it cannot loop.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('mealz:api-problem', (problem) => {
    if (!problem.isBrandSetupRequired) return
    try {
      nuxtApp.runWithContext(() => useUserAccess().fetchUserAccess(true)).catch(logFailure)
    } catch (error: unknown) {
      logFailure(error)
    }
  })
})
